export const IRRIGATE = 'IRRIGATE';
export const NO_IRRIGATION = 'NO_IRRIGATION';
export const FURROW = 'FURROW';
export const DRIP = 'DRIP';
